
import { Vue, Component, Prop } from 'vue-property-decorator';
import { ServiceToFilter } from './FiltersModal.vue';

@Component
export default class FilterItem extends Vue {
  @Prop({ default: () => [] }) service!: ServiceToFilter;

  get showItem(): boolean {
    return this.service.show;
  }

  set showItem(value: boolean) {
    this.$emit('toggleService', { value, name: this.service.name });
  }

  toggleLevel(value: boolean, selectedService: string): void {
    this.$emit('toggleLevel', { value, serviceName: this.service.name, selectedService });
  }
}
